module.exports = __webpack_public_path__ + "static/media/appstore.6a967c63.png";